module.exports = __webpack_public_path__ + "img/cement-expanding.3191eca1.jpg";